"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var SocialIcon_1 = __importDefault(require("./SocialIcon"));
var RegionSelector_1 = __importDefault(require("./RegionSelector"));
var Box_1 = __importDefault(require("../Box"));
var components_1 = require("./components");
var CopyRight_1 = __importDefault(require("./CopyRight"));
var FlexCol_1 = __importDefault(require("../FlexCol"));
function MobileFooter(props) {
    var _a = props || {}, regions = _a.regions, footerRegion = _a.footerRegion, navLinks = _a.navLinks, extraLinks = _a.extraLinks, socialLinks = _a.socialLinks, copyright = _a.copyright;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TopContent, null, navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (item) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LinkContainer, null, item.links.map(function (item) { return (react_1.default.createElement(components_1.NavLink, { key: item.text, href: item.url }, item.text)); })))); })),
        react_1.default.createElement(SocialIcon_1.default, { socialLinks: socialLinks }),
        react_1.default.createElement(components_1.Divider, null),
        react_1.default.createElement(BottomContent, null,
            react_1.default.createElement(BottomLinkContainer, null, extraLinks === null || extraLinks === void 0 ? void 0 : extraLinks.map(function (link) { return (react_1.default.createElement(components_1.BottomNavLink, { key: link.text, href: link.url }, link.text)); })),
            react_1.default.createElement(RegionSelector_1.default, { footerRegion: footerRegion, regions: regions })),
        react_1.default.createElement(components_1.Divider, null),
        react_1.default.createElement(CopyRight_1.default, { mt: '20px', pb: '49px', copyright: copyright })));
}
var TopContent = (0, styled_1.default)(FlexCol_1.default)({
    gap: '12px',
    paddingTop: '40px',
    paddingLeft: '18px',
    paddingRight: '18px',
});
var LinkContainer = (0, styled_1.default)(FlexCol_1.default)({
    paddingBottom: '12px',
    borderBottom: '0.5px solid rgba(255, 255, 255, 0.20)',
});
var BottomLinkContainer = (0, styled_1.default)(Box_1.default)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
    marginBottom: '10px'
});
var BottomContent = (0, styled_1.default)(FlexCol_1.default)({
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingRight: '18px',
    paddingLeft: '18px',
});
exports.default = MobileFooter;
